/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PolygonFilter
 */
export interface PolygonFilter {
    /**
     * 
     * @type {string}
     * @memberof PolygonFilter
     */
    type: PolygonFilterTypeEnum;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof PolygonFilter
     */
    coordinates: Array<Array<number>>;
}


/**
 * @export
 */
export const PolygonFilterTypeEnum = {
    PolygonFilter: 'PolygonFilter'
} as const;
export type PolygonFilterTypeEnum = typeof PolygonFilterTypeEnum[keyof typeof PolygonFilterTypeEnum];


/**
 * Check if a given object implements the PolygonFilter interface.
 */
export function instanceOfPolygonFilter(value: object): value is PolygonFilter {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function PolygonFilterFromJSON(json: any): PolygonFilter {
    return PolygonFilterFromJSONTyped(json, false);
}

export function PolygonFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolygonFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function PolygonFilterToJSON(json: any): PolygonFilter {
    return PolygonFilterToJSONTyped(json, false);
}

export function PolygonFilterToJSONTyped(value?: PolygonFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

